<template>
  <div class="w-full">
    <Panel header="Quản lý nhóm và thành viên trong nhóm">
      <div class="overflow-hidden rounded-lg border border-slate-200 bg-white">
        <div
          class="flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 bg-slate-50/80 p-4"
        >
          <div class="relative min-w-[280px] flex-1">
            <i
              class="pi pi-search pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400"
            />
            <InputText
              v-model="groupSearch"
              class="!pl-10"
              placeholder="Tìm theo tên nhóm"
            />
          </div>
          <div class="flex flex-wrap items-center gap-2">
            <Button
              label="Xoá đã chọn"
              icon="pi pi-trash"
              severity="danger"
              outlined
              @click="deleteSelectedGroups()"
              :loading="deletingGroups"
              :disabled="selectedGroupIds.length < 1"
            />
            <Button
              label="Thêm nhóm"
              icon="pi pi-plus-circle"
              @click="openAddGroupDialog()"
            />
          </div>
        </div>

        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-slate-200 text-sm">
            <thead
              class="bg-slate-100 text-left text-sm font-bold uppercase text-slate-600"
            >
              <tr>
                <th class="w-12 px-4 py-3.5">
                  <Checkbox
                    :modelValue="isAllGroupsSelected"
                    :binary="true"
                    @update:modelValue="toggleSelectAllGroups"
                  />
                </th>
                <th class="w-12 px-4 py-3.5"></th>
                <th class="px-4 py-3.5">Tên nhóm</th>
                <th class="px-4 py-3.5">Số thành viên</th>
                <th class="px-4 py-3.5">Thao tác</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-100 bg-white">
              <template v-if="filteredGroups.length">
                <template v-for="group in filteredGroups" :key="group.id">
                  <tr class="transition hover:bg-teal-50/45">
                    <td class="px-4 py-3.5">
                      <Checkbox
                        :modelValue="isGroupSelected(group.id)"
                        :binary="true"
                        @update:modelValue="toggleSelectGroup(group.id)"
                      />
                    </td>
                    <td class="px-4 py-3.5">
                      <button
                        type="button"
                        class="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:bg-slate-50"
                        @click="toggleGroup(group)"
                      >
                        <i
                          class="pi text-xs"
                          :class="
                            isExpanded(group.id)
                              ? 'pi-chevron-down'
                              : 'pi-chevron-right'
                          "
                        />
                      </button>
                    </td>
                    <td class="px-4 py-3.5 font-semibold text-slate-800">
                      {{ group.groupName }}
                    </td>
                    <td class="px-4 py-3.5 text-slate-600">
                      {{ memberCount(group.id) }}
                    </td>
                    <td class="px-4 py-3.5">
                      <div class="flex flex-wrap gap-2">
                        <Button
                          label="Thêm thành viên"
                          icon="pi pi-user-plus"
                          @click="openAddMemberDialog(group)"
                          class="!min-h-[36px] px-3 py-1.5"
                        />
                        <Button
                          label="Xoá nhóm"
                          icon="pi pi-trash"
                          severity="danger"
                          @click="deleteGroup(group.id)"
                          :loading="deletingGroupId === group.id"
                          class="!min-h-[36px] px-3 py-1.5"
                        />
                      </div>
                    </td>
                  </tr>

                  <tr v-if="isExpanded(group.id)" class="bg-slate-50/70">
                    <td colspan="5" class="px-4 pb-5 pt-2">
                      <div
                        class="overflow-hidden rounded-lg border border-slate-200 bg-white"
                      >
                        <div
                          class="flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 bg-white px-4 py-3"
                        >
                          <div class="font-bold text-slate-800">
                            Thành viên trong nhóm
                          </div>
                          <Button
                            label="Xoá đã chọn"
                            icon="pi pi-trash"
                            severity="danger"
                            outlined
                            @click="deleteSelectedMembers(group.id)"
                            :loading="deletingMembersGroupId === group.id"
                            :disabled="selectedMemberIds(group.id).length < 1"
                            class="!min-h-[36px] px-3 py-1.5"
                          />
                        </div>

                        <div class="overflow-x-auto">
                          <table
                            class="min-w-full divide-y divide-slate-200 text-sm"
                          >
                            <thead
                              class="bg-slate-100 text-left text-sm font-bold uppercase text-slate-600"
                            >
                              <tr>
                                <th class="w-12 px-4 py-3">
                                  <Checkbox
                                    :modelValue="isAllMembersSelected(group.id)"
                                    :binary="true"
                                    @update:modelValue="
                                      toggleSelectAllMembers(group.id, $event)
                                    "
                                  />
                                </th>
                                <th class="px-4 py-3">Tên thành viên</th>
                                <th class="px-4 py-3">Thao tác</th>
                              </tr>
                            </thead>
                            <tbody class="divide-y divide-slate-100 bg-white">
                              <tr v-if="loadingMembers[group.id]">
                                <td
                                  colspan="4"
                                  class="px-4 py-8 text-center font-medium text-slate-500"
                                >
                                  Đang tải thành viên
                                </td>
                              </tr>
                              <tr
                                v-else-if="members(group.id).length"
                                v-for="member in members(group.id)"
                                :key="member.id"
                                class="transition hover:bg-teal-50/40"
                              >
                                <td class="px-4 py-3">
                                  <Checkbox
                                    :modelValue="
                                      isMemberSelected(group.id, member.id)
                                    "
                                    :binary="true"
                                    @update:modelValue="
                                      toggleSelectMember(group.id, member.id)
                                    "
                                  />
                                </td>
                                <td
                                  class="px-4 py-3 font-medium text-slate-800"
                                >
                                  {{ member.zaloName }}
                                </td>

                                <td class="px-4 py-3">
                                  <Button
                                    label="Xoá"
                                    icon="pi pi-trash"
                                    severity="danger"
                                    @click="deleteMember(group.id, member.id)"
                                    :loading="deletingMemberId === member.id"
                                    class="!min-h-[34px] px-3 py-1.5"
                                  />
                                </td>
                              </tr>
                              <tr v-else>
                                <td
                                  colspan="4"
                                  class="px-4 py-8 text-center font-medium text-slate-500"
                                >
                                  Nhóm chưa có thành viên
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
              <tr v-else>
                <td
                  colspan="5"
                  class="px-4 py-10 text-center font-medium text-slate-500"
                >
                  Không có dữ liệu
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <Dialog
        v-model:visible="isAddGroupDialogVisible"
        header="Thêm nhóm"
        modal
        :style="{ width: 'min(520px, calc(100vw - 32px))' }"
      >
        <div class="flex flex-col">
          <label for="groupname">Tên nhóm</label>
          <InputText
            id="groupname"
            v-model="groupCreate.groupName"
            placeholder="Nhập tên nhóm"
            @keyup.enter="addGroup()"
          />
        </div>
        <template #footer>
          <div class="flex justify-end gap-2">
            <Button
              label="Huỷ"
              icon="pi pi-times"
              severity="secondary"
              outlined
              @click="closeAddGroupDialog()"
              :disabled="addingGroup"
            />
            <Button
              label="Thêm"
              icon="pi pi-plus-circle"
              @click="addGroup()"
              :loading="addingGroup"
              :disabled="!groupCreate.groupName"
            />
          </div>
        </template>
      </Dialog>

      <Dialog
        v-model:visible="isAddMemberDialogVisible"
        :header="`Thêm thành viên vào nhóm ${
          selectedGroupForMember?.groupName || ''
        }`"
        modal
        :style="{ width: 'min(620px, calc(100vw - 32px))' }"
      >
        <div class="flex flex-col">
          <label for="memberselect">Chọn thành viên</label>
          <MultiSelect
            id="memberselect"
            v-model="selectedCustomerIds"
            :options="listCustomer"
            optionLabel="name"
            optionValue="idMember"
            :filter="true"
            placeholder="Chọn thành viên"
          />
        </div>
        <template #footer>
          <div class="flex justify-end gap-2">
            <Button
              label="Huỷ"
              icon="pi pi-times"
              severity="secondary"
              outlined
              @click="closeAddMemberDialog()"
              :disabled="addingMember"
            />
            <Button
              label="Thêm"
              icon="pi pi-plus-circle"
              @click="addMember()"
              :loading="addingMember"
              :disabled="
                !selectedGroupForMember || selectedCustomerIds.length < 1
              "
            />
          </div>
        </template>
      </Dialog>

      <ConfirmDeleteModal
        v-model="showConfirmModal"
        :title="confirmTitle"
        :message="confirmMessage"
        :is-loading="isConfirming"
        @confirm="confirmAction"
        @cancel="cancelAction"
      />
    </Panel>
  </div>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import { useToast } from "@/ui/services/toast";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";
import { useConfirmDelete } from "@/composables/useConfirmDelete";
import { ListCustomer } from "@/models/listCustomer";
import zaloRepository from "@/services/ZaloRepository";
import { GroupCreate } from "@/models/groupCreate";
import { Group } from "@/models/group";
import { MemberInGroup } from "@/models/memberInGroup";

export default {
  components: {
    ConfirmDeleteModal,
  },
  setup() {
    const toast = useToast();
    const groupCreate = ref({} as GroupCreate);
    const listGroup = ref([] as Group[]);
    const listCustomer = ref([] as ListCustomer[]);
    const groupSearch = ref("");
    const expandedGroupIds = ref<number[]>([]);
    const selectedGroupIds = ref<number[]>([]);
    const membersByGroup = ref<Record<number, MemberInGroup[]>>({});
    const memberCountsByGroup = ref<Record<number, number>>({});
    const selectedMemberIdsByGroup = ref<Record<number, number[]>>({});
    const loadingMembers = ref<Record<number, boolean>>({});
    const isAddGroupDialogVisible = ref(false);
    const isAddMemberDialogVisible = ref(false);
    const selectedGroupForMember = ref<Group | null>(null);
    const selectedCustomerIds = ref<number[]>([]);
    const addingGroup = ref(false);
    const addingMember = ref(false);
    const deletingGroups = ref(false);
    const deletingGroupId = ref<number | null>(null);
    const deletingMemberId = ref<number | null>(null);
    const deletingMembersGroupId = ref<number | null>(null);
    const confirmDelete = useConfirmDelete();
    const showConfirmModal = confirmDelete.isOpen;
    const confirmTitle = confirmDelete.title;
    const confirmMessage = confirmDelete.message;
    const isConfirming = confirmDelete.isLoading;

    const openConfirm = (
      title: string,
      message: string,
      callback: () => Promise<void> | void,
    ) => {
      confirmDelete.open({
        title,
        message,
        onConfirm: callback,
      });
    };

    const confirmAction = () => {
      confirmDelete.confirm();
    };

    const cancelAction = () => {
      confirmDelete.cancel();
    };

    const filteredGroups = computed(() => {
      const keyword = groupSearch.value.trim().toLowerCase();
      if (!keyword) return listGroup.value;
      return listGroup.value.filter((group) =>
        group.groupName.toLowerCase().includes(keyword),
      );
    });

    const loadListGroup = () => {
      zaloRepository
        .listGroup()
        .then((response) => {
          listGroup.value = response.data;
          const groupIds = new Set(listGroup.value.map((group) => group.id));
          selectedGroupIds.value = selectedGroupIds.value.filter((id) =>
            groupIds.has(id),
          );
          memberCountsByGroup.value = listGroup.value.reduce(
            (counts, group) => ({
              ...counts,
              [group.id]: memberCountsByGroup.value[group.id],
            }),
            {} as Record<number, number>,
          );
          loadMemberCountsForGroups(listGroup.value);
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response?.data || "Lỗi khi tải danh sách nhóm",
            life: 2000,
          });
        });
    };

    const applyMembersForGroup = (
      groupId: number,
      groupMembers: MemberInGroup[],
    ) => {
      membersByGroup.value = {
        ...membersByGroup.value,
        [groupId]: groupMembers,
      };
      memberCountsByGroup.value = {
        ...memberCountsByGroup.value,
        [groupId]: groupMembers.length,
      };
      const currentIds = new Set(groupMembers.map((member) => member.id));
      selectedMemberIdsByGroup.value = {
        ...selectedMemberIdsByGroup.value,
        [groupId]: selectedMemberIds(groupId).filter((id) =>
          currentIds.has(id),
        ),
      };
    };

    const loadMemberCountsForGroups = (groups: Group[]) => {
      groups.forEach((group) => {
        zaloRepository.getListMemberInGroup(group.id).then((response) => {
          applyMembersForGroup(group.id, response.data as MemberInGroup[]);
        });
      });
    };

    const loadListMember = () => {
      zaloRepository
        .getListCustomer()
        .then((response) => {
          listCustomer.value = response.data;
        })
        .catch(() => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi khi tải danh sách công dân",
            life: 2000,
          });
        });
    };

    const loadMembersForGroup = (groupId: number) => {
      loadingMembers.value = { ...loadingMembers.value, [groupId]: true };
      return zaloRepository
        .getListMemberInGroup(groupId)
        .then((response) => {
          applyMembersForGroup(groupId, response.data as MemberInGroup[]);
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response?.data || "Lỗi khi tải thành viên trong nhóm",
            life: 2000,
          });
        })
        .finally(() => {
          loadingMembers.value = { ...loadingMembers.value, [groupId]: false };
        });
    };

    loadListGroup();
    loadListMember();

    const isExpanded = (groupId: number) =>
      expandedGroupIds.value.includes(groupId);

    const toggleGroup = (group: Group) => {
      if (isExpanded(group.id)) {
        expandedGroupIds.value = expandedGroupIds.value.filter(
          (id) => id !== group.id,
        );
        return;
      }
      expandedGroupIds.value = [...expandedGroupIds.value, group.id];
      loadMembersForGroup(group.id);
    };

    const members = (groupId: number) => membersByGroup.value[groupId] || [];
    const memberCount = (groupId: number) =>
      memberCountsByGroup.value[groupId] ?? "...";

    const isGroupSelected = (groupId: number) =>
      selectedGroupIds.value.includes(groupId);

    const isAllGroupsSelected = computed(
      () =>
        filteredGroups.value.length > 0 &&
        filteredGroups.value.every((group) =>
          selectedGroupIds.value.includes(group.id),
        ),
    );

    const toggleSelectGroup = (groupId: number) => {
      selectedGroupIds.value = isGroupSelected(groupId)
        ? selectedGroupIds.value.filter((id) => id !== groupId)
        : [...selectedGroupIds.value, groupId];
    };

    const toggleSelectAllGroups = (checked: boolean) => {
      selectedGroupIds.value = checked
        ? filteredGroups.value.map((group) => group.id)
        : [];
    };

    const selectedMemberIds = (groupId: number) =>
      selectedMemberIdsByGroup.value[groupId] || [];

    const isMemberSelected = (groupId: number, memberId: number) =>
      selectedMemberIds(groupId).includes(memberId);

    const isAllMembersSelected = (groupId: number) =>
      members(groupId).length > 0 &&
      members(groupId).every((member) =>
        selectedMemberIds(groupId).includes(member.id),
      );

    const toggleSelectMember = (groupId: number, memberId: number) => {
      const current = selectedMemberIds(groupId);
      selectedMemberIdsByGroup.value = {
        ...selectedMemberIdsByGroup.value,
        [groupId]: current.includes(memberId)
          ? current.filter((id) => id !== memberId)
          : [...current, memberId],
      };
    };

    const toggleSelectAllMembers = (groupId: number, checked: boolean) => {
      selectedMemberIdsByGroup.value = {
        ...selectedMemberIdsByGroup.value,
        [groupId]: checked ? members(groupId).map((member) => member.id) : [],
      };
    };

    const openAddGroupDialog = () => {
      groupCreate.value = {} as GroupCreate;
      isAddGroupDialogVisible.value = true;
    };

    const closeAddGroupDialog = () => {
      if (addingGroup.value) return;
      isAddGroupDialogVisible.value = false;
    };

    const addGroup = () => {
      if (!groupCreate.value.groupName || addingGroup.value) return;
      addingGroup.value = true;
      zaloRepository
        .createNewGroup(groupCreate.value)
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Thêm nhóm mới thành công",
            life: 2000,
          });
          isAddGroupDialogVisible.value = false;
          loadListGroup();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response?.data || "Thêm nhóm không thành công",
            life: 2000,
          });
        })
        .finally(() => {
          addingGroup.value = false;
        });
    };

    const openAddMemberDialog = (group: Group) => {
      selectedGroupForMember.value = group;
      selectedCustomerIds.value = [];
      isAddMemberDialogVisible.value = true;
    };

    const closeAddMemberDialog = () => {
      if (addingMember.value) return;
      isAddMemberDialogVisible.value = false;
    };

    const addMember = () => {
      if (
        !selectedGroupForMember.value ||
        selectedCustomerIds.value.length < 1 ||
        addingMember.value
      ) {
        return;
      }

      addingMember.value = true;
      zaloRepository
        .addListMemberInGroup({
          idList: selectedCustomerIds.value,
          idGroup: selectedGroupForMember.value.id,
        })
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Thêm thành viên vào nhóm thành công",
            life: 2000,
          });
          const groupId = selectedGroupForMember.value?.id;
          isAddMemberDialogVisible.value = false;
          selectedCustomerIds.value = [];
          if (groupId) loadMembersForGroup(groupId);
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response?.data || "Thêm thành viên không thành công",
            life: 2000,
          });
        })
        .finally(() => {
          addingMember.value = false;
        });
    };

    const removeGroup = (groupId: number) => {
      deletingGroupId.value = groupId;
      return zaloRepository
        .deleteGroup(groupId)
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Xoá nhóm thành công",
            life: 2000,
          });
          selectedGroupIds.value = selectedGroupIds.value.filter(
            (id) => id !== groupId,
          );
          expandedGroupIds.value = expandedGroupIds.value.filter(
            (id) => id !== groupId,
          );
          loadListGroup();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response?.data || "Xoá nhóm không thành công",
            life: 2000,
          });
        })
        .finally(() => {
          deletingGroupId.value = null;
        });
    };

    const deleteGroup = (groupId: number) => {
      const groupName =
        listGroup.value.find((group) => group.id === groupId)?.groupName ||
        "nhóm này";
      openConfirm(
        "Xác nhận xoá nhóm",
        `Bạn có chắc chắn muốn xoá ${groupName}?`,
        () => removeGroup(groupId),
      );
    };

    const deleteSelectedGroups = () => {
      if (selectedGroupIds.value.length < 1) return;
      const count = selectedGroupIds.value.length;
      openConfirm(
        "Xác nhận xoá nhóm",
        `Bạn có chắc chắn muốn xoá ${count} nhóm đã chọn?`,
        () => removeSelectedGroups(),
      );
    };

    const removeSelectedGroups = () => {
      deletingGroups.value = true;
      return Promise.all(
        selectedGroupIds.value.map((id) => zaloRepository.deleteGroup(id)),
      )
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Xoá nhóm đã chọn thành công",
            life: 2000,
          });
          selectedGroupIds.value = [];
          expandedGroupIds.value = [];
          loadListGroup();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response?.data || "Xoá nhóm đã chọn không thành công",
            life: 2000,
          });
        })
        .finally(() => {
          deletingGroups.value = false;
        });
    };

    const removeMember = (groupId: number, memberId: number) => {
      deletingMemberId.value = memberId;
      return zaloRepository
        .deleteListMemberInGroup({ idList: [memberId] })
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Xoá thành viên ra khỏi nhóm thành công",
            life: 2000,
          });
          selectedMemberIdsByGroup.value = {
            ...selectedMemberIdsByGroup.value,
            [groupId]: selectedMemberIds(groupId).filter(
              (id) => id !== memberId,
            ),
          };
          loadMembersForGroup(groupId);
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response?.data || "Xoá thành viên không thành công",
            life: 2000,
          });
        })
        .finally(() => {
          deletingMemberId.value = null;
        });
    };

    const deleteMember = (groupId: number, memberId: number) => {
      const memberName =
        members(groupId).find((member) => member.id === memberId)?.zaloName ||
        "thành viên này";
      openConfirm(
        "Xác nhận xoá thành viên",
        `Bạn có chắc chắn muốn xoá ${memberName} khỏi nhóm?`,
        () => removeMember(groupId, memberId),
      );
    };

    const deleteSelectedMembers = (groupId: number) => {
      const ids = selectedMemberIds(groupId);
      if (ids.length < 1) return;
      openConfirm(
        "Xác nhận xoá thành viên",
        `Bạn có chắc chắn muốn xoá ${ids.length} thành viên đã chọn khỏi nhóm?`,
        () => removeSelectedMembers(groupId),
      );
    };

    const removeSelectedMembers = (groupId: number) => {
      const ids = selectedMemberIds(groupId);
      deletingMembersGroupId.value = groupId;
      return zaloRepository
        .deleteListMemberInGroup({ idList: ids })
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Xoá thành viên đã chọn thành công",
            life: 2000,
          });
          selectedMemberIdsByGroup.value = {
            ...selectedMemberIdsByGroup.value,
            [groupId]: [],
          };
          loadMembersForGroup(groupId);
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail:
              err.response?.data || "Xoá thành viên đã chọn không thành công",
            life: 2000,
          });
        })
        .finally(() => {
          deletingMembersGroupId.value = null;
        });
    };

    return {
      groupCreate,
      listCustomer,
      groupSearch,
      filteredGroups,
      selectedGroupIds,
      isAllGroupsSelected,
      isGroupSelected,
      toggleSelectGroup,
      toggleSelectAllGroups,
      isExpanded,
      toggleGroup,
      members,
      memberCount,
      loadingMembers,
      selectedMemberIds,
      isMemberSelected,
      isAllMembersSelected,
      toggleSelectMember,
      toggleSelectAllMembers,
      openAddGroupDialog,
      closeAddGroupDialog,
      addGroup,
      openAddMemberDialog,
      closeAddMemberDialog,
      addMember,
      deleteGroup,
      deleteSelectedGroups,
      deleteMember,
      deleteSelectedMembers,
      isAddGroupDialogVisible,
      isAddMemberDialogVisible,
      selectedGroupForMember,
      selectedCustomerIds,
      addingGroup,
      addingMember,
      deletingGroups,
      deletingGroupId,
      deletingMemberId,
      deletingMembersGroupId,
      showConfirmModal,
      confirmTitle,
      confirmMessage,
      isConfirming,
      confirmAction,
      cancelAction,
    };
  },
};
</script>
